import { Spinner as SpinnerComponent } from 'react-bootstrap';

import { LoaderContainer, LoaderWrapper } from './styled';

export const Spinner = () => (
  <SpinnerComponent animation="border" role="status">
    <span className="visually-hidden">Loading...</span>
  </SpinnerComponent>
);

const Loader = ({ fullscreen }: { fullscreen?: boolean }) => {
  return (
    <LoaderContainer $fullscreen={fullscreen ?? false}>
      <LoaderWrapper>
        <Spinner />
      </LoaderWrapper>
    </LoaderContainer>
  );
};

export default Loader;
